
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aboutu8Sb32ihwPMeta } from "/app/pages/about.vue?macro=true";
import { default as contactsHSHl3sOssUMeta } from "/app/pages/contacts.vue?macro=true";
import { default as galleryvsTGmCPX6gMeta } from "/app/pages/gallery.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as restaurant2kvR8jr0amMeta } from "/app/pages/restaurant.vue?macro=true";
import { default as roomsIuLRaOKdGzMeta } from "/app/pages/rooms.vue?macro=true";
export default [
  {
    name: "about___ru",
    path: "/about",
    meta: aboutu8Sb32ihwPMeta || {},
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    meta: aboutu8Sb32ihwPMeta || {},
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "contacts___ru",
    path: "/contacts",
    meta: contactsHSHl3sOssUMeta || {},
    component: () => import("/app/pages/contacts.vue")
  },
  {
    name: "contacts___en",
    path: "/en/contacts",
    meta: contactsHSHl3sOssUMeta || {},
    component: () => import("/app/pages/contacts.vue")
  },
  {
    name: "gallery___ru",
    path: "/gallery",
    meta: galleryvsTGmCPX6gMeta || {},
    component: () => import("/app/pages/gallery.vue")
  },
  {
    name: "gallery___en",
    path: "/en/gallery",
    meta: galleryvsTGmCPX6gMeta || {},
    component: () => import("/app/pages/gallery.vue")
  },
  {
    name: "index___ru",
    path: "/",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexN6pT4Un8hYMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "restaurant___ru",
    path: "/restaurant",
    meta: restaurant2kvR8jr0amMeta || {},
    component: () => import("/app/pages/restaurant.vue")
  },
  {
    name: "restaurant___en",
    path: "/en/restaurant",
    meta: restaurant2kvR8jr0amMeta || {},
    component: () => import("/app/pages/restaurant.vue")
  },
  {
    name: "rooms___ru",
    path: "/rooms",
    meta: roomsIuLRaOKdGzMeta || {},
    component: () => import("/app/pages/rooms.vue")
  },
  {
    name: "rooms___en",
    path: "/en/rooms",
    meta: roomsIuLRaOKdGzMeta || {},
    component: () => import("/app/pages/rooms.vue")
  }
]